import { Outlet } from 'react-router-dom';
import BrandLoader from '@sdk/components/ui/BrandLoader';

import { useGetConversations } from '@web/conversations/hooks/useGetConversations';

import { useConversationServerReconnectionSync } from './hooks/useConversationServerReconnectionSync';
import { useConversationsSocketListener } from './hooks/useConversationsSocketListener';
import { useStatusServiceUpdater } from './hooks/useStatusServiceUpdater';
import { LoaderWrapper } from './conversationsRootPage.styles';

export const ConversationsRootPage = () => {
  const { isLoading } = useGetConversations();
  useConversationsSocketListener();
  useStatusServiceUpdater();
  useConversationServerReconnectionSync();

  return isLoading ? (
    <LoaderWrapper>
      <BrandLoader />
    </LoaderWrapper>
  ) : (
    <Outlet />
  );
};
